import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { premiumForecasts } from '../../../redux/reducers/premiumSlice';
import { navigation_geo_select_geo, navigation_toggle_open } from '../../../redux/reducers/navigationSlice';
import { PrimaryTabs } from '@emarketer/componentlibrary';
import HomeContent from '../HomeContent/HomeContent';
import config from '../../../config';

/**
 * TODO:
 * Premium code is left in place under comments for the future use
 */

interface IHomeTabState {
  selectedChannel: string;
  showAll: boolean;
}

function mapStateToProps(state) {
  return {
    SelectedChannel: state.navigation.selectedChannel,
    SelectedGeography: state.navigation.selectedGeography,
    Channels: state.navigation.channels,
    CompareCountries: state.navigation.compareCountries,
    selectedCompareCountriesTopic: state.navigation.selectedCompareCountriesTopic,
    isLoggedIn: state.auth.authenticated,
    loaded: state.navigation.loaded,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    selectGeography: (geography) => {
      dispatch(navigation_geo_select_geo(geography));
    },
    openNavToggle: () => {
      dispatch(navigation_toggle_open());
    },
  };
};

class HomeTabs extends React.Component<
  {
    isMobile: boolean;
    Channels: any;
    SelectedChannel: any;
    selectedCompareCountriesTopic: any;
    CompareCountries: any;
    loaded: boolean;
  },
  IHomeTabState
> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { isMobile, Channels, SelectedChannel, loaded, selectedCompareCountriesTopic, CompareCountries } = this.props;

    let channelData = null;

    if (SelectedChannel === 'Compare Countries') {
      if (selectedCompareCountriesTopic === 'All') {
        const sortedCompareCountriesCollections = CompareCountries.flatMap((item) => item.Collections);
        sortedCompareCountriesCollections.sort((a, b) => {
          const nameA = a.Name.toLowerCase();
          const nameB = b.Name.toLowerCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        channelData = {
          TopicId: '999',
          TopicName: 'Compare Countries',
          Collections: sortedCompareCountriesCollections,
        };
      } else {
        channelData = CompareCountries.find((obj) => obj.TopicName === selectedCompareCountriesTopic);
      }
    } else {
      channelData = Channels.find((obj) => obj.TopicName === SelectedChannel);
    }

    let channelPremiumData: string[] = [];
    const isCollectionPremium = (id) => {
      return premiumForecasts.some((f) => f.collectionId === id);
    };

    channelData?.Collections.forEach((item) => {
      if (isCollectionPremium(item.Id)) channelPremiumData.push(item);
    });

    const handleTabChange = (tabKey) => {
      window.iiAna('track', 'Forecasts-Index-Tab', {
        tab: tabKey,
      });
    };

    const displayPremiumFeatures = config.enableNonPremiumFeatures;

    return (
      <Container>
        <PrimaryTabs
          callback={handleTabChange}
          size={isMobile ? 'default' : 's'}
          minTabWidth={isMobile ? '50%' : '100px'}
          spaceBetween={isMobile ? 0 : 38}
          hideBorder
          tabs={[
            {
              tabKey: 'All',
              content: loaded ? (
                <HomeContent channelTitle={'Test'} templateList={channelData.Collections} isMobile={isMobile} />
              ) : null,
            },
            ...(displayPremiumFeatures && channelPremiumData.length > 0
              ? [
                  {
                    tabKey: 'PRO+ ',
                    content: loaded ? (
                      <HomeContent channelTitle={'Test'} templateList={channelPremiumData} isMobile={isMobile} />
                    ) : null,
                  },
                ]
              : []),
          ]}
        />
      </Container>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeTabs);

const Container = styled.div``;
